import React from "react";
import "./DashboardWidgets.css";
import {
  MdPeople,
  MdPendingActions,
  MdLibraryBooks,
  MdAttachMoney,
  MdBarChart,
  MdTrendingUp,
} from "react-icons/md";

const DashboardWidgets = ({ users }) => {
  const totalStudents = users.length;
  const pendingApprovals = users.filter(u => u.status === "pending").length;
  const activeCourses = new Set(users.map(u => u.course_name)).size;
  const pendingFees = 12450;
  const approvalRate = Math.round((pendingApprovals / totalStudents) * 100) || 0;
  const growthRate = 17.4; // Example: could be fetched dynamically

  const widgets = [
    {
      title: "Total Students",
      value: totalStudents,
      icon: <MdPeople />,
      color: "blue",
      trend: `+${growthRate}% from last month`,
    },
    {
      title: "Pending Approvals",
      value: pendingApprovals,
      icon: <MdPendingActions />,
      color: "yellow",
      trend: "Check enrollment requests",
    },
    {
      title: "Active Courses",
      value: activeCourses,
      icon: <MdLibraryBooks />,
      color: "green",
      trend: "Curriculum expanding",
    },
    {
      title: "Pending Fees",
      value: `$${pendingFees.toLocaleString()}`,
      icon: <MdAttachMoney />,
      color: "red",
      trend: "Payment follow-ups pending",
    },
    {
      title: "Approval Rate",
      value: `${approvalRate}%`,
      icon: <MdBarChart />,
      color: "purple",
      trend: approvalRate > 50 ? "Improving" : "Needs review",
    },
    {
      title: "Growth Rate",
      value: `${growthRate}%`,
      icon: <MdTrendingUp />,
      color: "teal",
      trend: "Month-over-month increase",
    },
  ];

  return (
    <div className="dashboard">
      <div className="widgets-header">
        <h2>Dashboard Overview</h2>
        <p>Key metrics for admin insights</p>
      </div>
      <div className="widgets-container">
        {widgets.map((w, index) => (
          <div key={index} className={`widget-card ${w.color}`}>
            <div className="widget-top">
              <div className="widget-icon">{w.icon}</div>
              <div className="widget-info">
                <h3>{w.value}</h3>
                <p>{w.title}</p>
              </div>
            </div>
            <div className="widget-footer">
              <span className="widget-trend">{w.trend}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardWidgets;
